module.exports = __webpack_public_path__ + "img/bg_01.86868024.jpg";